import {LocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/enum/LocaleType'
import {findLocaleTypeFromLanguageTag} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/functions/findLocaleTypeFromLanguageTag'

/** The first of the browser's preferred languages (navigator.languages order) that the app has translations for. */
export function findPreferredLocaleType(
  languageTags: readonly string[],
  translatedLocales: readonly string[],
): LocaleType | null {
  for(const languageTag of languageTags) {
    const locale = findLocaleTypeFromLanguageTag(languageTag)
    if(locale && translatedLocales.includes(locale)) {
      return locale
    }
  }
  return null
}
